export const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

export const endPoints = {
  createFaceLivenessSession: "age-estimation/verification",
  startVerificationSession: "verification",
  verifyFace: "verification",
  trackPageVisiting: "verification",
};

export const constants = {};
